/* eslint-disable no-unused-vars */
import React, { useContext } from 'react';
import { CotizadorContext } from '../context';

const useLegalUrl= () => {
    const [state, setState] = useContext(CotizadorContext)



    const setLegalUrl= (legal_url) => {
        setState((prevState) => ({
            ...prevState,
            legal_url,
        }));
    };

    return {
        legal_url: state.legal_url,
        setLegalUrl,
    };
}

export default useLegalUrl;